import React from "react"

import { gql, useQuery } from "urql"

import StudyGroupsTable from "~Tutor/components/StudyGroupsTable"
import { WithLoadingIndicator } from "~tailwindui/Basics"

const StudyGroupsNeedingScheduling = () => {
  const [result] = useQuery({
    query: studyGroupsNeedingSchedulingQuery,
  })

  if (result.data && result.data.viewer.studyGroups.data.length === 0)
    return (
      <span className="mt-8 italic">
        No study groups need scheduling at this time.
      </span>
    )

  return (
    <div>
      <WithLoadingIndicator result={result}>
        {({ data: { viewer } }) => (
          <StudyGroupsTable
            studyGroups={viewer.studyGroups}
            title="Newly Accepted Study Groups"
          />
        )}
      </WithLoadingIndicator>
    </div>
  )
}

const studyGroupsNeedingSchedulingQuery = gql`
  query StudyGroupsNeedingScheduling {
    viewer {
      studyGroups(needingScheduling: true) {
        data {
          id
          name
          students {
            id
            fullName
            avatar {
              thumbUrl
            }
          }
          subjects {
            id
            name
          }
          allAvailabilities {
            id
            startsAt
            endsAt
            weekday
          }
        }
      }
    }
  }
`

export default StudyGroupsNeedingScheduling
